import {
  KeyboardCombinationsPlatforms,
  KeyboardCombinationType,
} from 'hooks/useKeydownSubscription';

export enum Events {
  OPEN_CATALOG_DRAWER = 'OPEN_CATALOG_DRAWER',
  ADD_CUSTOM_FIELD = 'ADD_CUSTOM_FIELD',
}

export const KEYBOARD_EVENT_COMBINATIONS: Record<
  Events,
  Record<KeyboardCombinationsPlatforms, KeyboardCombinationType>
> = {
  [Events.ADD_CUSTOM_FIELD]: {
    mac: {
      key: 'm',
      ctrlKey: false,
      metaKey: true,
    },
    windows: {
      key: 'm',
      ctrlKey: true,
      metaKey: false,
    },
  },
  [Events.OPEN_CATALOG_DRAWER]: {
    mac: {
      key: 'k',
      ctrlKey: false,
      metaKey: true,
    },
    windows: {
      key: 'k',
      ctrlKey: true,
      metaKey: false,
    },
  },
};
